// James Madison University's bachelor's majors (#2839). Read on 2026-10-01
// from JMU's official 2026-2027 Academic Catalog (catalog.jmu.edu, "2026-2027
// Edition"): every program the catalog's program search tags "Bachelor's
// Degrees", with the degree the catalog names (B.A., B.S., B.B.A., B.F.A.,
// B.M., B.S.N., B.S.W., B.I.S.). Grouped by the college whose academic units
// list the program (each college page's Academic Units tab, then each unit's
// Programs tab). Three units sit outside the seven colleges in the catalog and
// keep their own groups: the Hart School of Hospitality, Sport and Recreation
// Management, Interdisciplinary Liberal Studies (under University Studies)
// and the Adult Degree Program (School of Professional and Continuing
// Education). Biotechnology is listed by both the College of Science and
// Mathematics and the College of Integrated Science and Engineering; it
// appears once, under Science and Mathematics, with a note. International
// Business is listed by both International Business and World Languages and
// Cultures; it appears under the College of Business. Left out: minors,
// pre-professional programs, certificates and graduate programs.
const majors = {
    "slug": "james-madison-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in JMU's official 2026-2027 Academic Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, pre-professional programs, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Letters",
            "source": {
                "label": "JMU 2026-2027 Academic Catalog, College of Arts and Letters",
                "url": "https://catalog.jmu.edu/colleges/college-arts-letters/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.S."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "International Affairs",
                    "degree": "B.A."
                },
                {
                    "name": "Justice Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Justice Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Media Arts and Design",
                    "degree": "B.A."
                },
                {
                    "name": "Media Arts and Design",
                    "degree": "B.S."
                },
                {
                    "name": "Modern Foreign Languages",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy and Religion, Major in Global Religions and Cultures",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy and Religion, Major in Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Public Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.S."
                },
                {
                    "name": "Writing, Rhetoric and Technical Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Writing, Rhetoric and Technical Communication",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "JMU 2026-2027 Academic Catalog, College of Business",
                "url": "https://catalog.jmu.edu/colleges/college-business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.B.A."
                },
                {
                    "name": "Business Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "B.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.B.A."
                },
                {
                    "name": "International Business",
                    "degree": "B.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.B.A."
                },
                {
                    "name": "Quantitative Finance Major with a Minor in Economics and Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Quantitative Finance/Mathematics Double Major",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "JMU 2026-2027 Academic Catalog, College of Education",
                "url": "https://catalog.jmu.edu/colleges/college-education/"
            },
            "majors": [
                {
                    "name": "Elementary Education",
                    "degree": "B.S."
                },
                {
                    "name": "Inclusive Early Childhood Education",
                    "degree": "B.S."
                },
                {
                    "name": "Middle Grades Education",
                    "degree": "B.S."
                },
                {
                    "name": "Secondary Education",
                    "degree": "B.S."
                },
                {
                    "name": "Special Education",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Health and Behavioral Studies",
            "source": {
                "label": "JMU 2026-2027 Academic Catalog, College of Health and Behavioral Studies",
                "url": "https://catalog.jmu.edu/colleges/college-health-behavioral-studies/"
            },
            "majors": [
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "B.S."
                },
                {
                    "name": "Dietetics",
                    "degree": "B.S."
                },
                {
                    "name": "Health Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Health Services Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Kinesiology",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                },
                {
                    "name": "Nursing, R.N. to B.S.N.",
                    "degree": "B.S.N.",
                    "note": "For registered nurses completing a bachelor's degree."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        },
        {
            "name": "College of Integrated Science and Engineering",
            "source": {
                "label": "JMU 2026-2027 Academic Catalog, College of Integrated Science and Engineering",
                "url": "https://catalog.jmu.edu/colleges/college-integrated-science-engineering/"
            },
            "majors": [
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.S."
                },
                {
                    "name": "Information Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Integrated Science and Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Intelligence Analysis",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Science and Mathematics",
            "source": {
                "label": "JMU 2026-2027 Academic Catalog, College of Science and Mathematics",
                "url": "https://catalog.jmu.edu/colleges/college-science-mathematics/"
            },
            "majors": [
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biotechnology",
                    "degree": "B.S.",
                    "note": "Offered jointly by the Department of Biology, the Department of Chemistry and Biochemistry, and the School of Integrated Sciences; both colleges list it."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry, Biophysical Chemistry Major",
                    "degree": "B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.A."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Geology, Environmental Earth Science Major",
                    "degree": "B.A."
                },
                {
                    "name": "Geology, Environmental Earth Science Major",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Visual and Performing Arts",
            "source": {
                "label": "JMU 2026-2027 Academic Catalog, College of Visual and Performing Arts",
                "url": "https://catalog.jmu.edu/colleges/college-visual-performing-arts/"
            },
            "majors": [
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Art, Architectural Design Major",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art",
                    "degree": "B.S."
                },
                {
                    "name": "Art, Graphic Design Major",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art, Industrial Design Major",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.M."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre, Dance Major",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre, Musical Theatre Major",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Hart School of Hospitality, Sport and Recreation Management",
            "source": {
                "label": "JMU 2026-2027 Academic Catalog, Hart School of Hospitality, Sport and Recreation Management",
                "url": "https://catalog.jmu.edu/academic-departments/hart-school-hospitality-sport-recreation-management/"
            },
            "majors": [
                {
                    "name": "Hospitality Management",
                    "degree": "B.S."
                },
                {
                    "name": "Sport and Recreation Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "University Studies",
            "source": {
                "label": "JMU 2026-2027 Academic Catalog, University Studies",
                "url": "https://catalog.jmu.edu/colleges/university-studies/"
            },
            "note": "University Studies is the dean's office for Interdisciplinary Liberal Studies, Independent Scholars and General Studies; the catalog lists these majors under Interdisciplinary Liberal Studies.",
            "majors": [
                {
                    "name": "Individualized Study, General Studies Major",
                    "degree": "B.A."
                },
                {
                    "name": "Individualized Study, General Studies Major",
                    "degree": "B.S."
                },
                {
                    "name": "Individualized Study, Independent Scholars Major",
                    "degree": "B.A."
                },
                {
                    "name": "Individualized Study, Independent Scholars Major",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Professional and Continuing Education",
            "source": {
                "label": "JMU 2026-2027 Academic Catalog, School of Professional and Continuing Education",
                "url": "https://catalog.jmu.edu/colleges/school-professional-continuing-education/"
            },
            "note": "The Adult Degree Program's Individualized Study major, for students at least 22 years old with at least 30 transferable semester hours.",
            "majors": [
                {
                    "name": "Individualized Study",
                    "degree": "B.A."
                },
                {
                    "name": "Individualized Study",
                    "degree": "B.I.S."
                },
                {
                    "name": "Individualized Study",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
